import React from 'react';

import { RefundFormValues, RefundFormViolation } from 'types/refundTypes';
import {
  createRefundFormValues,
  createRefundFormViolationLense,
} from 'utils/refundUtils';
import { stringIsEmpty, stringIsUSDAmount } from 'utils/stringUtils';

export const useRefundForm = () => {
  const [values, setValues] = React.useState<RefundFormValues>(
    createRefundFormValues
  );

  const [violations, setViolations] = React.useState<RefundFormViolation[]>([]);

  const setComment = React.useCallback((nextValue: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      comment: nextValue,
    }));

    setViolations((prev) =>
      prev.filter(
        (violation) =>
          !createRefundFormViolationLense(violation).isCommentViolation()
      )
    );
  }, []);

  const setAmount = React.useCallback((nextValue: string) => {
    if (stringIsEmpty(nextValue) || stringIsUSDAmount(nextValue)) {
      setValues((prevValues) => ({
        ...prevValues,
        amount: nextValue,
      }));

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createRefundFormViolationLense(violation).isAmountViolation()
        )
      );
    }
  }, []);

  return {
    values,
    violations,
    setValues,
    setViolations,
    setAmount,
    setComment,
  };
};
